import { render, staticRenderFns } from "./FormItemTableCell.vue?vue&type=template&id=22dfb78c&scoped=true"
import script from "./FormItemTableCell.vue?vue&type=script&lang=js"
export * from "./FormItemTableCell.vue?vue&type=script&lang=js"
import style0 from "./FormItemTableCell.vue?vue&type=style&index=0&id=22dfb78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfb78c",
  null
  
)

export default component.exports